import { ReportType } from 'compliance-api';
import { Select, TooltipNew } from 'ui';
import { InfoCircleIcon } from 'ui/icons';
import { fixNameEnum } from 'ui/utils';

export const mapReportTypeToName: Record<string, string> = {
  [ReportType.IncidentReport]: 'Event Report',
};

const mapReportTypeToDescription: Record<ReportType, string> = {
  [ReportType.TaskActivityReport]:
    'See what tasks were done, who did them, when, and their compliance status.',
  [ReportType.OverdueTasksReport]: 'This report shows us all the overdue tasks.',
  [ReportType.TaskResultsReport]:
    'Everything in the Task Activity Report, plus full details on individual questions and answers.',
  [ReportType.IncidentReport]: 'A log of answers from event submissions.',
  [ReportType.BatchReport]: 'Combined PDF file that includes several other reports.',
};

export const reportTypesOptions = Object.values(ReportType).map(value => ({
  value,
  label: (
    <div className="flex items-center justify-between pr-2">
      <span>{mapReportTypeToName[value] || fixNameEnum(value)}</span>
      <TooltipNew text="" html={mapReportTypeToDescription[value]} positionStrategy="fixed">
        <img
          width={20}
          src={InfoCircleIcon}
          alt="info"
          className="hidden [[class*='option']_&]:block"
        />
      </TooltipNew>
    </div>
  ),
}));

interface ReportTypeSelectProps {
  disabled?: boolean;
  value?: ReportType;
  hideBatch?: boolean;
  onChange?: (value: ReportType | null) => void;
}

const ReportTypeSelect = ({ value, disabled, hideBatch, onChange }: ReportTypeSelectProps) => {
  return (
    <Select<ReportType>
      disabled={disabled}
      label="Report type"
      value={value}
      options={
        hideBatch
          ? reportTypesOptions.filter(({ value }) => value !== ReportType.BatchReport)
          : reportTypesOptions
      }
      onChange={onChange}
      optionStyles={{ paddingRight: 0 }}
    />
  );
};

export default ReportTypeSelect;
